import { SecondaryTradeResource } from 'app/_services/secondaryTradeService';
import { DATES } from 'app/_constants/dates.constant';
import * as angular from 'angular';
import { config } from 'angular/utils/config';

class SecondaryProposalDetailsComponentCtrl implements ng.IController {
    id: number;
    isLoggedIn: boolean;
    authenticatedUser: LoginResult;
    uiLoading: boolean;
    uiLoadingError: boolean;
    headlineTitle: string;
    state: string;
    appBaseUrl: string;
    proposal: ProposalDto;
    pdfExportUrl: any;
    ownProposal: boolean;
    ownResponse: boolean;
    tsoShipperNote0: string[];
    tsoShipperNote1: string[];

    constructor(
        private reportingService: any,
        private auctionResource: any,
        private TradeProposals: any,
        private SecondaryTrade: SecondaryTradeResource,
        private DATES: DATES
    ) {}

    $onInit(): void {
        this.appBaseUrl = config.appBaseUrl;
        this.isLoggedIn = !!this.authenticatedUser;
        this.uiLoading = true;
        this.uiLoadingError = false;
        this.TradeProposals.get(
            { id: this.id },
            (res) => {
                this.proposal = res;
                this.tsoShipperNote0 = [res.tsoShipperNote0];
                this.tsoShipperNote1 = [res.tsoShipperNote1];
                this.state = res.state;
                this.pdfExportUrl =
                    this.reportingService.mapExportUrls(
                        this.reportingService.REPORT.SECONDARY.PROPOSAL,
                        'PDF'
                    ) +
                    '?id=' +
                    this.id;
                this.ownProposal = res.ownProposal;
                this.ownResponse = res.ownResponse;
            },
            this.onError.bind(this)
        ).$promise.finally(this.onFinally.bind(this));
    }

    onError() {
        this.uiLoadingError = true;
    }

    onFinally() {
        this.uiLoading = false;
    }
}

angular.module('app').component('pkpSecondaryProposalDetails', {
    controller: SecondaryProposalDetailsComponentCtrl,
    template:
        require('app/secondary-trading/secondary-proposal-details.component.html'),
    bindings: {
        id: '<',
        authenticatedUser: '<'
    }
});
